import { api } from "./api";
import type { ImageTrialStateView } from "@/types/imageTrial";

// Source: PROD-PRICING-I-2 (Starter Image-Generation Trial).
//   - Surface contract: docs/product/experience-and-ui.md § Starter Image-Generation Trial.
//   - Visual hierarchy: docs/product/experience-and-ui.md § Cross-cutting § Starter Image Trial banner.
//   - Endpoint contract: docs/engineering/contracts/HTTP_API.md
//     `GET /api/v1/billing/image-trial-state`.

export async function fetchImageTrialState(): Promise<ImageTrialStateView> {
  const { data } = await api.get<ImageTrialStateView>(
    "/api/v1/billing/image-trial-state",
  );
  return data;
}
